import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Settings from '@material-ui/icons/Settings';
import { Switch, Redirect } from 'react-router-dom';

import PrivateRoute from 'yeself-client-common/security/components/PrivateRoute';

import DetailWrapper from 'Console/components/common/detailWrapper/DetailWrapper';
import AccountsSettings from 'Console/components/accounts/detail/settings/Settings';

import { fetchAccountDetail, fetchAccountUnmount } from 'Console/data/accounts/actions';
import { ROUTES } from 'Console/constants/routes';

const styles = () => ({
    icon: {
        'margin-right': 10,
        'font-size': 24,
        height: 28,
    },
});

class AccountDetail extends Component {
    componentDidMount() {
        const { match, fetchAccountDetail } = this.props;
        fetchAccountDetail(match.params.accountId);
    }

    componentWillUnmount() {
        const { fetchAccountUnmount } = this.props;
        fetchAccountUnmount();
    }

    navLinks = (url) => {
        const { intl, classes } = this.props;
        return [
            {
                id: 'account-settings',
                displayName: intl.formatMessage({ id: 'Accounts.navigation.detail.settings' }),
                navLinkTo: `${url}${ROUTES.SETTINGS}`,
                component: AccountsSettings,
                icon: <Settings className={classes.icon} />,
            },
        ];
    };

    render() {
        const { match } = this.props;

        return (
            <DetailWrapper
                matchUrl={match.url}
                params={match.params}
                navLinks={this.navLinks(match.url)}
            >
                <Switch>
                    {this.navLinks(match.path).map((route) => (
                        <PrivateRoute
                            key={`route-${route.navLinkTo}`}
                            path={route.navLinkTo}
                            params={match.params}
                            component={route.component}
                        />
                    ))}
                    <Redirect
                        key="redirect"
                        from={match.url}
                        to={{
                            pathname: `${match.url}${ROUTES.SETTINGS}/general`,
                            accountId: match.params.accountId,
                        }}
                    />
                </Switch>
            </DetailWrapper>
        );
    }
}

export default withStyles(styles)(
    injectIntl(
        connect(null, {
            fetchAccountDetail,
            fetchAccountUnmount,
        })(AccountDetail)
    )
);
